/**
 * Les identifiants du patron ARIA `combobox` d'une saisie en place : l'élément
 * édité (dans le rendu) et la liste de suggestions (dans un portail) doivent se
 * désigner l'un l'autre, et ils vivent dans deux fichiers.
 *
 * Module à part : un export non-composant depuis le `.jsx` de la liste casserait
 * le Fast Refresh de Vite (`react-refresh/only-export-components`), dont le
 * symptôme est une zone de l'écran qui disparaît sans trace.
 */

export const SUGGEST_LIST_ID = 'builder-inline-suggest-list'

/** L'identifiant d'une option, pour `aria-activedescendant`. */
export const suggestOptionId = (index) => `${SUGGEST_LIST_ID}-${index}`
